<template>
  <div v-if="computedDdpTag && computedDdpTag.length > 0">
    <div class="cdp-title">
      <el-tag size="small" class="cdp-title-tag">CDP标签：
        <el-popover placement="top-start" width="420" trigger="hover">
          <div v-for="(item, index) in CDPDefinitionFormat" :key="index">
            <div class="cdp-def-item">
              <div class="cdp-def-item-title">{{ item.name }}：</div>
              <div class="cdp-def-item-content">{{ item.content }}</div>
            </div>
          </div>
          <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference"></i>
        </el-popover>
      </el-tag>
    </div>
    <el-tag class="cdp-tag" size="small" type="warning" effect="plain" v-for="({key, val, hideKey}, index) in computedDdpTag" :key="index">{{ hideKey ? val : `${key}：${val}` }}</el-tag>
  </div>
</template>

<script>
export default {
  props: {
    cdpTag: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dealer: this.$common.getLoginInfo().profile,
      // 海洋CDP标签
      oceanCDP:[
        { name: '预测线上购车周期人群', content: '近30天内在懂车帝/汽车之家等平台搜索/浏览过比亚迪竞品品牌指定车系，且处于购车周期内客户。竞对车系:34C、迈腾亚洲龙雅阁帕萨特、小P7+、小米SU7、极氪007、智界S7等' },
        { name: '预测学历', content: '基于友盟三方数据预测的客户学历层级' },
        { name: '预测收入水平', content: '基于友盟三方数据预测的客户收入层级' },
        { name: '预测消费水平', content: '基于客户日常消费习惯，消费档次预测的消费层级。档位越高代表消费水平越高' },
        { name: '预测婚否', content: '客户婚姻情况' },
        { name: '智慧评级', content: 'V1-V5（由低到高）价值度越高代表客户线索质量越好' },
        { name: '到店次数', content: '半年内累计到店次数，在试驾前到全部海洋店次数' },
      ],
      // 海洋门店重点标签（写死的白名单，海洋门店仅展示这些标签）
      oceanKeyTags: [
        '预测线上购车周期人群',
        '预测学历',
        '预测收入水平',
        '预测消费水平',
        '预测婚否',
      ],
      // 王朝CDP标签
      dynastyCDP:[
        { name: '智慧评级', content: '低中高' },
        { name: '到店次数', content: '半年内累计到店次数，在试驾前到全部王朝店次数' },
      ],
      CDPDefinition: [
        { name: '试驾次数', content: '半年内累计试驾次数' },
        { name: '车辆用途', content: '预计购买车辆的使用用途，智蛛客户自述' },
        { name: '意向车系', content: '预计购买本品的意向车系' },
        { name: '竞品车系', content: '预计购买竞品的意向车系' },
        { name: '手机号归属地', content: '客户手机号归属地' },
        { name: '站内信偏好', content: '客户站内信点击率' },
        { name: '添加企微导购', content: '客户是否添加企微导购' },
        { name: '外观偏好', content: '购车个性化外观偏好' },
        { name: '内饰偏好', content: '购车个性化内饰偏好' },
        { name: '选装偏好', content: '购车个性化选装偏好' },
      ],
      // 预测收入水平：档位值转义映射（展示为含区间的描述），key 同步改为"收入水平"
      incomeLevelMap: {
        '5档收入': '5档（10001-50000）',
        '1档收入': '1档（<=2000以下）',
        '4档收入': '4档（6001-10000）',
        '3档收入': '3档（4001-6000）',
        '6档收入': '6档（>50000）',
        '2档收入': '2档（2001-4000）',
      },
      // 预测消费水平：档位值转义映射（展示为消费层级），key 同步改为"预测水平"
      consumeLevelMap: {
        '5档消费': '高',
        '3档消费': '中',
        '4档消费': '中高',
        '1档消费': '低',
        '6档消费': '超高',
        '2档消费': '中低',
      },
    }
  },
  computed: {
    // 海洋门店 type 1王朝 2海洋
    isOceanCDP() {
      return this.dealer.type === 2
    },
    CDPDefinitionFormat() {
      return this.isOceanCDP ? [...this.oceanCDP, ...this.CDPDefinition] : [...this.dynastyCDP, ...this.CDPDefinition]
    },
    computedDdpTag() {
      let value = []
      for(const ele of this.cdpTag) {
        const val = Object.values(ele)[0]
        const key = Object.keys(ele)[0]
        // 边界情况：ele 为空对象时 Object.keys/values 不报错，但 key/val 为 undefined，直接跳过
        if(key === undefined) continue
        // 海洋门店：仅展示写死的重点标签
        // if(this.isOceanCDP && !this.oceanKeyTags.includes(key)) continue
        if(val !== "" && val !== '0') {
          // if
          // 预测收入水平/预测消费水平：值按映射转义，key 同步改名；映射未命中时保留原值与原 key
          // if (key === '预测收入水平' && this.incomeLevelMap[val] !== undefined) {
          //   value.push({key: '收入水平', val: this.incomeLevelMap[val]})
          // } else if (key === '预测消费水平' && this.consumeLevelMap[val] !== undefined) {
          //   value.push({key: '预测水平', val: this.consumeLevelMap[val]})
          // } else {
          //   // 预测学历/预测婚否：hideKey 标志位为 true，模板中仅展示值、不展示"key："前缀
          //   const hideKey = key === '预测学历' || key === '预测婚否'
            // value.push(hideKey ? {key, val, hideKey: true} : {key, val})
          // }

          // else
          value.push({key, val})
        }
      }
      return value
    }
  }
}
</script>

<style scoped>
.cdp-title {
  margin-top: 10px;
  margin-bottom: 8px;
}

.cdp-title-tag {
  background-color: white;
}

.cdp-def-item {
  display: flex;
}

.cdp-def-item-title {
  width: 100px;
}

.cdp-def-item-content {
  flex: 1
}

.cdp-tag {
  margin-right: 3px;
  margin-bottom: 3px;
  color: #606266;
}
</style>